import {MatOption, MatOptionSelectionChange} from '@angular/material/core';
import {AppSelectElementDirective} from '@component/form/input/select/select-element.directive';
import {HostBinding, Optional} from '@angular/core';
import {Subscription} from 'rxjs';

export abstract class AbstractSearchSelectDirective {
    readonly #option: MatOption;

    readonly #select: AppSelectElementDirective;

    #filtered: boolean = false;

    @HostBinding('class.mat-option--hidden')
    hidden: boolean = false;

    constructor(
        option: MatOption,
        @Optional() select: AppSelectElementDirective,
    ) {
        this.#option = option;
        this.#select = select;
    }

    ngOnInit(): void {
        this.#select.register(this);
    }

    getLabel(): string {
        return this.#option.getLabel();
    }

    setSelected(selected: boolean): void {
        selected ? this.#option.select() : this.#option.deselect();
    }

    isSelected(): boolean {
        return this.#option.selected;
    }

    update(): void {
        this.hidden = this.#filtered;
    }

    setFiltered(value: boolean): void {
        this.#filtered = value;
    }

    isFiltered(): boolean {
        return this.#filtered;
    }

    subscribe(fn: (event: MatOptionSelectionChange) => void): Subscription {
        return this.#option.onSelectionChange.subscribe((event: MatOptionSelectionChange) => fn(event));
    }
}
